import React, { memo } from 'react'

import useEnhancedModelCompatibility from 'Pods/ThreeDStudio/Hooks/useEnhancedModelCompatibility'
import AIEngineSelector from 'Pods/ThreeDStudio/Shared/AIEngineSelector/AIEngineSelector'
import GenerateArea from 'Pods/ThreeDStudio/Shared/GenerateArea/GenerateArea'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { ACTION, HIDDEN_ENHANCED_PROVIDERS_BY_ACTION } from 'Pods/ThreeDStudio/Store/constants'

import ExampleSection from './Components/ExampleSection/ExampleSection'
import FaceLevelSelector from './Components/FaceLevelSelector/FaceLevelSelector'
import PolygonTypeSelector from './Components/PolygonTypeSelector/PolygonTypeSelector'
import SmartLowPolySelector from './Components/SmartLowPolySelector/SmartLowPolySelector'

const HIDDEN_PROVIDERS = HIDDEN_ENHANCED_PROVIDERS_BY_ACTION[ACTION.MESH_SIMPLIFICATION]

function RemeshTab() {
  const { isModelIncompatible, tooltipMessage } = useEnhancedModelCompatibility()
  const isImageUploading = useThreeDStudioStore(state => state.ui?.isImageUploading)

  return (
    <>
      <div className="enhance-model-panel__tab remesh-tab">
        <span className="enhance-model-panel__title cgt-heading-50">Remesh</span>
        <div className="enhance-model-panel__settings">
          <SmartLowPolySelector />
          <PolygonTypeSelector />
          <FaceLevelSelector />
          <AIEngineSelector isEnhanced hiddenProviders={HIDDEN_PROVIDERS} />
        </div>
        <ExampleSection />
      </div>
      <GenerateArea
        generateLabel="Remesh"
        generatedLabel="Done"
        generatingLabel="Processing..."
        isEnhancementMode
        isGenerateDisabled={isImageUploading || isModelIncompatible}
        tooltipMessage={tooltipMessage}
        withIcon={false}
      />
    </>
  )
}

export default memo(RemeshTab)
